/**
 * Login Modal - Espace Mon Projet
 * Handles the login modal: open/close, AJAX login, password toggle.
 *
 * Uses querySelectorAll so it works regardless of how many headers
 * are present in the DOM (main header + frontpage header).
 */

document.addEventListener("DOMContentLoaded", function () {
  // Target the FIRST visible modal (position:fixed so it renders fine)
  const modal = document.getElementById("login-modal");

  if (!modal) return; // Not in DOM → user is logged in

  const form = document.getElementById("login-modal-form");
  const messages = document.getElementById("login-modal-messages");
  const submitBtn = document.getElementById("login-submit-btn");

  // =========================================================
  // OPEN / CLOSE  (handle ALL trigger/close buttons in DOM)
  // =========================================================

  function openModal() {
    modal.classList.remove("hidden");
    modal.classList.add("flex");
    document.body.style.overflow = "hidden";
    document.getElementById("login-email")?.focus();
  }

  function closeModal() {
    modal.classList.add("hidden");
    modal.classList.remove("flex");
    document.body.style.overflow = "";
    clearMessages();
  }

  // Attach to every open button in the page (main header + frontpage header)
  document
    .querySelectorAll('[id="open-login-modal"], [data-open-login-modal]')
    .forEach((btn) => {
      btn.addEventListener("click", openModal);
    });

  // Attach to every close button
  document.querySelectorAll('[id="close-login-modal"]').forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });

  // Close on backdrop click
  // Track mousedown origin to avoid closing when user drags a selection
  // from inside the modal and releases on the backdrop
  let mousedownTarget = null;
  modal.addEventListener("mousedown", function (e) {
    mousedownTarget = e.target;
  });
  modal.addEventListener("click", function (e) {
    if (e.target === modal && mousedownTarget === modal) closeModal();
  });

  // Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });

  // =========================================================
  // AUTO-OPEN FROM URL PARAM  ?open-modal=login
  // (used by "Retour à la connexion" and "Déjà un compte ?" links)
  // =========================================================

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("open-modal") === "login") {
    openModal();

    // Clean the URL param without page reload
    const cleanUrl =
      window.location.pathname +
      window.location.search
        .replace(/[?&]open-modal=login/, "")
        .replace(/^&/, "?");
    window.history.replaceState(
      {},
      document.title,
      cleanUrl || window.location.pathname,
    );
  }

  // =========================================================
  // PASSWORD TOGGLE
  // =========================================================

  const togglePass = document.getElementById("toggle-login-password");
  const passInput = document.getElementById("login-password");

  if (togglePass && passInput) {
    togglePass.addEventListener("click", function () {
      const isHidden = passInput.type === "password";
      passInput.type = isHidden ? "text" : "password";
      togglePass.querySelector(".eye-off").classList.toggle("hidden", isHidden);
      togglePass.querySelector(".eye-on").classList.toggle("hidden", !isHidden);
    });
  }

  // =========================================================
  // FORM SUBMIT (AJAX LOGIN)
  // =========================================================

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearMessages();

      const email = document.getElementById("login-email")?.value.trim();
      const password = passInput?.value;
      const remember = document.getElementById("login-remember")?.checked;
      const nonce = form.querySelector('input[name="login_nonce"]')?.value;

      if (!email || !password) {
        showMessage("Veuillez remplir tous les champs.", "error");
        return;
      }

      const originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML =
        '<span class="inline-block animate-spin mr-2">↻</span> Connexion...';

      const formData = new FormData();
      formData.append("action", "user_login");
      formData.append("nonce", nonce || "");
      formData.append("email", email);
      formData.append("password", password);
      if (remember) formData.append("remember", "1");

      // CleanTalk compatibility: pass bot-detector token if present on page
      if (window.apbct && window.apbct.checkjs_val !== undefined) {
        formData.append("ct_checkjs", window.apbct.checkjs_val);
      }

      fetch(loginModal.ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((r) => r.json())
        .then((data) => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;

          if (data.success) {
            showMessage(data.data?.message || "Connexion réussie !", "success");
            setTimeout(() => {
              window.location.href = data.data?.redirect || "/";
            }, 800);
          } else {
            showMessage(
              data.data?.message || "Une erreur est survenue.",
              "error",
            );
          }
        })
        .catch(() => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          showMessage(
            "Une erreur réseau est survenue. Veuillez réessayer.",
            "error",
          );
        });
    });
  }

  // =========================================================
  // MESSAGES
  // =========================================================

  function showMessage(msg, type) {
    if (!messages) return;
    const colors = {
      success: "bg-green-100 border-green-400 text-green-700",
      error: "bg-red-100 border-red-400 text-red-700",
    };
    messages.className = `mb-4 p-3 border-l-4 text-sm ${colors[type] || colors.error}`;
    messages.textContent = msg;
    messages.classList.remove("hidden");
  }

  function clearMessages() {
    if (!messages) return;
    messages.classList.add("hidden");
    messages.textContent = "";
  }
});
